import type { OctopusFeatureToggle } from "@octopusdeploy/octopus-server-client";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useOctopusFeatureToggle(toggle: OctopusFeatureToggle, defaultValue: boolean) {
    return useBooleanFlagValue(toggle, defaultValue);
}
export function usePlatformHubOctopusFeatureToggles() {
    const processTemplates = useBooleanFlagValue("blueprints", false);
    const projectTemplates = useBooleanFlagValue("project-templates", false);
    const compliancePolicies = useBooleanFlagValue("compliance-policies", false);
    const enabled = processTemplates || processTemplates || compliancePolicies;
    return { enabled, processTemplates, projectTemplates, compliancePolicies };
}
export interface PlatformHubOctopusFeatureToggles {
    enabled: boolean;
    processTemplates: boolean;
    projectTemplates: boolean;
    compliancePolicies: boolean;
}
